import React from 'react';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';


const EventPopupModal = ({ event, onClose, onDontShowToday }) => {
  if (!event) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-[9999]">
      <div className="bg-white rounded-lg max-w-sm w-full overflow-hidden transform transition-all duration-300 scale-95 opacity-0 animate-fade-in-scale">
        
        <Link to={`/event/${event.id}`} className="cursor-pointer">
          {/* Image Section */}
          {event.image_url && (
            <div className="w-full h-48">
              <img src={event.image_url} alt={event.title} className="w-full h-full object-cover" />
            </div>
          )}

          {/* Content Section */}
          <div className="p-6">
<h3 className="text-xl font-bold text-gray-900 mb-2">{event.title}</h3>
                    <p className="text-gray-600 text-sm mb-6 whitespace-pre-line line-clamp-4">{event.description}</p>
          </div>
        </Link>

        {/* Footer with Buttons */}
        <div className="px-6 py-4 bg-gray-50 flex justify-between items-center">
          <button
            onClick={onDontShowToday}
            className="text-xs text-gray-500 hover:text-gray-800 transition-colors"
          >
            오늘 하루 보지 않기
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-800 text-white rounded-md hover:bg-gray-900 transition-colors text-sm font-medium"
          >
            닫기
          </button>
        </div>

      </div>
      {/* Close button on top-right of the screen */}
      <button 
        onClick={onClose} 
        className="absolute top-4 right-4 text-white hover:text-gray-300 transition-opacity"
        aria-label="Close popup"
      >
        <X size={28} />
      </button>

<style jsx>{`
          @keyframes fade-in-scale {
            from {
              transform: scale(0.95);
              opacity: 0;
            }
            to {
              transform: scale(1);
              opacity: 1;
            }
          }
          .animate-fade-in-scale {
            animation: fade-in-scale 0.3s ease-out forwards;
          }
          .line-clamp-4 {
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        `}</style>
    </div>
  );
};

export default EventPopupModal;
